/* istanbul ignore file */
import BasePage from '../../components/base-page/base-page';

import './affiliates-landing-promo.scss';


class AffiliatesLandingPromo extends BasePage {

  uiCollections = {
    appItems: '[data-app-href]',
  };

  events = {
    'click @uiCollections.appItems': 'handleClickApp',
  };

  onInit() {
    super.onInit();
  }

  //TODO: add analytics event

  handleClickApp(e) {
    const { appHref } = e.currentTarget.dataset;

    window.open(appHref, '_blank', 'noopener,noreferrer');
  }
}

export default AffiliatesLandingPromo;

(AffiliatesLandingPromo as BasePage).initOnDomLoaded();
